#import "./AddressFull.graphql"
#import "./CompanyFull.graphql"

fragment OrderCustomerFull on OrderCustomer {
  billingAddress {
    ...AddressFull
  }
  contactAddress {
    ...AddressFull
  }
  company {
    ...CompanyFull
  }
  companyName
  contact {
    email
    phoneNumber
  }
  gdprApprovedAt
  fullName
}
